export const sagasDashboardActivities = [];
